import { ReactNode, useEffect, useState } from 'react'
import { createPortal } from 'react-dom'

interface IProps {
  children: ReactNode
}

export const Portal = ({ children }: IProps) => {
  const [container] = useState(document.createElement('div'))
  const [wasAppendedContainer, setWasAppendedContainer] = useState(false)

  useEffect(() => {
    if (document.body) {
      document.body.appendChild(container)
    }

    setWasAppendedContainer(true)

    return () => {
      document.body.removeChild(container)
    }
  }, [container])

  return wasAppendedContainer ? createPortal(children, container) : null
}
